import React from 'react';

const ControlsWrapper = (props) => {
    return (
        <div className="PathFinder panel panel-body ">
            <div className="row">
                {props.children}
            </div>
        </div>
    )
};

export default ControlsWrapper